import { useRef, useState } from "react";
import { motion } from "framer-motion";

export const PortfolioCard = ({ project, onOpen, index }) => {
  const videoRef = useRef(null);
  const [hovered, setHovered] = useState(false);

  const handleEnter = () => {
    setHovered(true);
    if (videoRef.current) {
      videoRef.current.currentTime = 0;
      videoRef.current.play().catch(() => {});
    }
  };
  const handleLeave = () => {
    setHovered(false);
    if (videoRef.current) videoRef.current.pause();
  };

  const isPlaceholder = !!project.placeholder;

  return (
    <motion.button
      layoutId={`card-${project.id}`}
      onClick={() => !isPlaceholder && onOpen(project)}
      onMouseEnter={handleEnter}
      onMouseLeave={handleLeave}
      whileHover={{ y: -4 }}
      transition={{ type: "spring", stiffness: 220, damping: 22 }}
      data-testid={`portfolio-card-${project.id}`}
      className={`group relative block w-full text-left border-r border-b border-divider ${
        isPlaceholder ? "cursor-default" : "cursor-pointer"
      }`}
    >
      <div className="relative aspect-[9/16] w-full overflow-hidden bg-[#0a0a0a]">
        {/* Index marker */}
        <div className="absolute top-3 left-3 z-20 font-mono text-[10px] uppercase tracking-[0.25em] text-white/70">
          [{project.index}]
        </div>
        <div className="absolute top-3 right-3 z-20 font-mono text-[10px] uppercase tracking-[0.25em] text-white/60">
          {project.year}
        </div>

        {isPlaceholder ? (
          <div className="absolute inset-0 flex flex-col items-center justify-center gap-3">
            <div className="w-14 h-14 border border-divider flex items-center justify-center">
              <span className="font-mono text-xl text-rust">+</span>
            </div>
            <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/50">
              Próximamente
            </div>
          </div>
        ) : (
          <>
            <video
              ref={videoRef}
              src={project.src}
              muted
              loop
              playsInline
              preload="auto"
              onLoadedMetadata={(e) => {
                try {
                  e.currentTarget.currentTime = 0.5;
                } catch (_) {}
              }}
              className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-500 ${
                hovered ? "opacity-70" : "opacity-100"
              }`}
            />
            {/* Bottom gradient for text legibility */}
            <div className="absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-black via-black/60 to-transparent pointer-events-none" />
          </>
        )}

        {/* Slide-up title */}
        {!isPlaceholder && (
          <div className="absolute inset-x-0 bottom-0 p-4 md:p-5 z-10">
            <motion.div
              initial={false}
              animate={{
                y: hovered ? 0 : 14,
                opacity: hovered ? 1 : 0.9,
              }}
              transition={{ type: "spring", stiffness: 240, damping: 24 }}
            >
              <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-rust mb-2">
                {project.category}
              </div>
              <div className="font-display uppercase text-lg md:text-xl leading-[1.05] text-white">
                {project.title}
              </div>
              <motion.div
                initial={false}
                animate={{ opacity: hovered ? 1 : 0, y: hovered ? 0 : 6 }}
                transition={{ duration: 0.25 }}
                className="mt-3 font-mono text-[10px] uppercase tracking-[0.25em] text-white/70 flex items-center gap-2"
              >
                <span className="w-6 h-px bg-white/60" />
                Ver reel
              </motion.div>
            </motion.div>
          </div>
        )}
      </div>
    </motion.button>
  );
};
